module.exports = __webpack_public_path__ + "fbStatic/fonts/element-icons.732389de.ttf";